const verificationCodeLength: number = 6;

export { verificationCodeLength };
